import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAsterisk } from "@fortawesome/free-solid-svg-icons";

export const RequiredMarker = (props) => {
  return <FontAwesomeIcon icon={faAsterisk} size="xs" color="red" />;
};
